<template>
  <div id="update-data-page">
    <h2 class="intro-y text-lg font-medium mt-10">
      更改類別
    </h2>

    <forum-category-form v-if="mounted && checkPermission(permissions, 'site.forum-category.edit')" :site="currentSite" :data="data"></forum-category-form>

    <div v-else-if="mounted">
      <div class="alert alert-danger show mt-2" role="alert">沒有權限查看</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['auth', 'currentSite', 'permissions'],
  data() {
    return {
      mounted: false,
      data: null
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    permissions() {
      this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.permissions) {
        await this.loadData()

        setTimeout(() => {
          this.mounted = true
        }, 500)
      }
    },
    async loadData() {
      if (this.currentSite) {
        this.data = await this.getSiteForumCategory(this.currentSite.site_id, this.$route.params.categoryId)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
